import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateDate',
    standalone: false
})
export class TranslateDatePipe implements PipeTransform {

  private daysOfWeek = {
    Sunday: 'ראשון',
    Monday: 'שני',
    Tuesday: 'שלישי',
    Wednesday: 'רביעי',
    Thursday: 'חמישי',
    Friday: 'שישי',
    Saturday: 'שבת'
  };

  private months = {
    January: 'ינואר',
    February: 'פברואר',
    March: 'מרץ',
    April: 'אפריל',
    May: 'מאי',
    June: 'יוני',
    July: 'יולי',
    August: 'אוגוסט',
    September: 'ספטמבר',
    October: 'אוקטובר',
    November: 'נובמבר',
    December: 'דצמבר'
  };
  
    transform(value: string, type: 'day' | 'month'): string {
      if (type === 'day') {
        return this.daysOfWeek[value] || value;
      } else if (type === 'month') {
        return this.months[value] || value;
      }
      return value;
    }
  

}
